import React from "react";
import { Helmet } from "react-helmet";
import { CustomerPortal } from "../../App/components/organisms";

const CustomerPage: React.FC = () => (
  <>
    <Helmet>
      <title>Poupas for holidays - Πελάτης</title>
    </Helmet>
    <CustomerPortal />
  </>
);

export default CustomerPage;
